import { useParams } from "react-router-dom";
import SeoPageLayout from "@/components/SeoPageLayout";
import NotFound from "@/pages/NotFound";
import { serviceBySlug } from "@/data/services";

export default function DienstDetail() {
  const { slug } = useParams();
  const entry = serviceBySlug(slug);
  if (!entry) return <NotFound />;

  return (
    <SeoPageLayout
      entry={entry}
      eyebrow="Dienst"
      schemaType="Service"
      testid={`page-dienst-${entry.slug}`}
      breadcrumb={[
        { name: "Home", path: "/" },
        { name: "Diensten", path: "/diensten" },
        { name: entry.navLabel, path: entry.to },
      ]}
    />
  );
}
